import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrAuthorizedEmployeeCardHrmTypeModel')
export class AuthorizedEmployeeCardHrmTypeModel {
    @EmptyControl()
    @JsonProperty('hrmTypeUuid', String, true)
    hrmTypeUuid: string = null;

    @EmptyControl()
    @JsonProperty('canEdit', Boolean, true)
    canEdit: boolean = null;

    @EmptyControl()
    @JsonProperty('canRead', Boolean, true)
    canRead: boolean = null;
}
